"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.MewsPaymentInfoType = exports.TerminalPaymentErrorType = exports.PaymentErrorType = exports.PaymentType = exports.PaymentMethodTypeIdType = exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType[PaymentMethodType["Unknown"] = -1] = "Unknown";
    PaymentMethodType[PaymentMethodType["None"] = 0] = "None";
    PaymentMethodType[PaymentMethodType["Custom"] = 1] = "Custom";
    PaymentMethodType[PaymentMethodType["Adyen"] = 2] = "Adyen";
    PaymentMethodType[PaymentMethodType["Cash"] = 3] = "Cash";
    PaymentMethodType[PaymentMethodType["Rounding"] = 4] = "Rounding";
    PaymentMethodType[PaymentMethodType["Tip"] = 5] = "Tip";
    PaymentMethodType[PaymentMethodType["Invoice"] = 6] = "Invoice";
    PaymentMethodType[PaymentMethodType["CashBack"] = 7] = "CashBack";
    PaymentMethodType[PaymentMethodType["Mews"] = 8] = "Mews";
    PaymentMethodType[PaymentMethodType["GiftCards"] = 9] = "GiftCards";
    PaymentMethodType[PaymentMethodType["External"] = 10] = "External";
    PaymentMethodType[PaymentMethodType["Deliverect"] = 11] = "Deliverect";
    PaymentMethodType[PaymentMethodType["PrepaidWallet"] = 12] = "PrepaidWallet";
    PaymentMethodType[PaymentMethodType["Retain24GiftCards"] = 13] = "Retain24GiftCards";
    PaymentMethodType[PaymentMethodType["Nets"] = 14] = "Nets";
    PaymentMethodType[PaymentMethodType["MPSGiftCards"] = 15] = "MPSGiftCards";
    PaymentMethodType[PaymentMethodType["Manual"] = 16] = "Manual";
    PaymentMethodType[PaymentMethodType["Como"] = 17] = "Como";
    PaymentMethodType[PaymentMethodType["Stammy"] = 18] = "Stammy";
    PaymentMethodType[PaymentMethodType["Surfboard"] = 19] = "Surfboard";
    PaymentMethodType[PaymentMethodType["Maitres"] = 20] = "Maitres";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PaymentMethodTypeIdType;
(function (PaymentMethodTypeIdType) {
    PaymentMethodTypeIdType[PaymentMethodTypeIdType["None"] = 0] = "None";
    PaymentMethodTypeIdType[PaymentMethodTypeIdType["Physical"] = 1] = "Physical";
    PaymentMethodTypeIdType[PaymentMethodTypeIdType["Virtual"] = 2] = "Virtual";
})(PaymentMethodTypeIdType = exports.PaymentMethodTypeIdType || (exports.PaymentMethodTypeIdType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Full"] = 1] = "Full";
    PaymentType[PaymentType["Part"] = 2] = "Part";
    PaymentType[PaymentType["CertainItems"] = 3] = "CertainItems";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PaymentErrorType;
(function (PaymentErrorType) {
    PaymentErrorType[PaymentErrorType["Terminal"] = 0] = "Terminal";
    PaymentErrorType[PaymentErrorType["Mews"] = 1] = "Mews";
    PaymentErrorType[PaymentErrorType["GiftCards"] = 2] = "GiftCards";
    PaymentErrorType[PaymentErrorType["Como"] = 3] = "Como";
    PaymentErrorType[PaymentErrorType["Stammy"] = 4] = "Stammy";
})(PaymentErrorType = exports.PaymentErrorType || (exports.PaymentErrorType = {}));
var TerminalPaymentErrorType;
(function (TerminalPaymentErrorType) {
    TerminalPaymentErrorType[TerminalPaymentErrorType["Unknown"] = -1] = "Unknown";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Aborted"] = 0] = "Aborted";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Busy"] = 1] = "Busy";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Cancel"] = 2] = "Cancel";
    TerminalPaymentErrorType[TerminalPaymentErrorType["DeviceOut"] = 3] = "DeviceOut";
    TerminalPaymentErrorType[TerminalPaymentErrorType["InsertedCard"] = 4] = "InsertedCard";
    TerminalPaymentErrorType[TerminalPaymentErrorType["InProgress"] = 5] = "InProgress";
    TerminalPaymentErrorType[TerminalPaymentErrorType["LoggedOut"] = 6] = "LoggedOut";
    TerminalPaymentErrorType[TerminalPaymentErrorType["MessageFormat"] = 7] = "MessageFormat";
    TerminalPaymentErrorType[TerminalPaymentErrorType["NotAllowed"] = 8] = "NotAllowed";
    TerminalPaymentErrorType[TerminalPaymentErrorType["NotFound"] = 9] = "NotFound";
    TerminalPaymentErrorType[TerminalPaymentErrorType["PaymentRestriction"] = 10] = "PaymentRestriction";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Refusal"] = 11] = "Refusal";
    TerminalPaymentErrorType[TerminalPaymentErrorType["UnavailableDevice"] = 12] = "UnavailableDevice";
    TerminalPaymentErrorType[TerminalPaymentErrorType["UnavailableService"] = 13] = "UnavailableService";
    TerminalPaymentErrorType[TerminalPaymentErrorType["InvalidCard"] = 14] = "InvalidCard";
    TerminalPaymentErrorType[TerminalPaymentErrorType["UnreachableHost"] = 15] = "UnreachableHost";
    TerminalPaymentErrorType[TerminalPaymentErrorType["WrongPIN"] = 16] = "WrongPIN";
    TerminalPaymentErrorType[TerminalPaymentErrorType["TransactionUnknown"] = 17] = "TransactionUnknown";
    TerminalPaymentErrorType[TerminalPaymentErrorType["TransactionAbandoned"] = 18] = "TransactionAbandoned";
    TerminalPaymentErrorType[TerminalPaymentErrorType["VerificationNotPossible"] = 19] = "VerificationNotPossible";
    TerminalPaymentErrorType[TerminalPaymentErrorType["TimeOut"] = 20] = "TimeOut";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Duplicate"] = 21] = "Duplicate";
    TerminalPaymentErrorType[TerminalPaymentErrorType["Ancon"] = 22] = "Ancon";
    TerminalPaymentErrorType[TerminalPaymentErrorType["InsufficientBalance"] = 23] = "InsufficientBalance";
})(TerminalPaymentErrorType = exports.TerminalPaymentErrorType || (exports.TerminalPaymentErrorType = {}));
var MewsPaymentInfoType;
(function (MewsPaymentInfoType) {
    MewsPaymentInfoType[MewsPaymentInfoType["Room"] = 0] = "Room";
    MewsPaymentInfoType[MewsPaymentInfoType["Reservation"] = 1] = "Reservation";
})(MewsPaymentInfoType = exports.MewsPaymentInfoType || (exports.MewsPaymentInfoType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    /** The payment doesn't have a status, it was just created */
    PaymentStatus[PaymentStatus["None"] = -1] = "None";
    /** The payment is processing the transaction */
    PaymentStatus[PaymentStatus["Processing"] = 0] = "Processing";
    /** The payment is completed and can be included in any calculations needed */
    PaymentStatus[PaymentStatus["Completed"] = 1] = "Completed";
    /** The payment failed for some reason */
    PaymentStatus[PaymentStatus["Error"] = 2] = "Error";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
